module.exports = __webpack_public_path__ + "img/1_2023_07_19.9cbeb100.jpg";